/* global window */
import { supportLocalStorage } from './localStorage';
import { FILTER_DRAWER } from 'Constants/filters';

const setQuickFilterFeatureFlag = data => {
    if (supportLocalStorage()) {
        window.localStorage.setItem('quick_filters', data);
    }
};

const readQuickFilterFeatureFlag = () => {
    if (supportLocalStorage()) {
        const quickFilterFlag = window.localStorage.getItem('quick_filters');

        return quickFilterFlag ? JSON.parse(quickFilterFlag) : false;
    }

    return false;
};

function computeDrawerHeight(appliedFilters, quickFilters) {
    const total = appliedFilters.length + quickFilters.length;
    const length = {
        first: 0,
        second: 0
    };
    const response = {};

    if (total === 0 || total < FILTER_DRAWER.EXTERNAL_TRIGGER_THRESHOLD) {
        return {
            drawerOpenHeight: FILTER_DRAWER.MIN_HEIGHT,
            contentHeight: FILTER_DRAWER.MIN_HEIGHT - FILTER_DRAWER.ALT_PADDING
        };
    }

    appliedFilters.forEach(filter => {
        if (filter.props && filter.props.prefix) {
            length.second += 1;
        }
        else {
            length.first += 1;
        }
    });

    length.first += quickFilters.length;

    const rows = Math.round(((length.first * FILTER_DRAWER.FIRST_WIDTH) + (length.second * FILTER_DRAWER.SECOND_WIDTH)) / FILTER_DRAWER.MAX_ROW_WIDTH);

    response.contentHeight = rows * FILTER_DRAWER.TAG_HEIGHT;

    let computedHeight = response.contentHeight + FILTER_DRAWER.PADDING;

    if (computedHeight > FILTER_DRAWER.MAX_HEIGHT) {
        computedHeight = FILTER_DRAWER.MAX_HEIGHT;
    }
    else if (computedHeight < FILTER_DRAWER.MIN_HEIGHT) {
        computedHeight = FILTER_DRAWER.MIN_HEIGHT;
    }

    return {
        ...response,
        drawerOpenHeight: computedHeight
    };
}

export {
    setQuickFilterFeatureFlag,
    readQuickFilterFeatureFlag,
    computeDrawerHeight
};

